// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wu zQ","ribbon":"wv zZ","title":"ww zS","seasons":"wx zX","genres":"wy zY","buttonWrapper":"wz zU","button":"wA zV"};